import type { DiagramProps } from '@/lib/scad-feature-types';
import { D } from './DiagramStyles';

export function UnionDiagram(_props: DiagramProps) {
  // A: rectangle on left, B: circle overlapping right side
  const ax = 60, ay = 60, aW = 70, aH = 50;
  const bcx = 120, bcy = 85, br = 28;

  // Result panel: combined outline shape (simplified as the union bounding shape)
  const rx = 190;

  return (
    <svg viewBox="0 0 280 150" width="100%" style={{ display: 'block' }} aria-label="Union diagram">
      <defs>
        <clipPath id="u-rect-clip">
          <rect x={ax} y={ay} width={aW} height={aH} />
        </clipPath>
        <clipPath id="u-circ-clip">
          <circle cx={bcx} cy={bcy} r={br} />
        </clipPath>
      </defs>

      {/* Labels */}
      <text x={ax + aW / 2} y={ay - 8} fontSize="10" fontFamily="monospace"
            fill="currentColor" opacity="0.6" textAnchor="middle">A</text>
      <text x={bcx + 22} y={bcy - br - 4} fontSize="10" fontFamily="monospace"
            fill="currentColor" opacity="0.6" textAnchor="middle">B</text>

      {/* A: rectangle */}
      <rect x={ax} y={ay} width={aW} height={aH}
            fill="rgba(96,165,250,0.15)" stroke={D.GEO_STROKE} strokeWidth="1.5" />

      {/* B: circle */}
      <circle cx={bcx} cy={bcy} r={br}
              fill="rgba(34,197,94,0.15)" stroke="#22c55e" strokeWidth="1.5" />

      {/* Plus sign */}
      <text x={155} y={87} fontSize="18" fontFamily="monospace"
            fill="currentColor" opacity="0.5" textAnchor="middle">+</text>

      {/* Result arrow */}
      <text x={168} y={87} fontSize="14" fontFamily="monospace"
            fill="currentColor" opacity="0.4" textAnchor="middle">=</text>

      {/* Result: union (both filled, as one) */}
      <g transform={`translate(${rx - 80}, 0)`}>
        <rect x={ax} y={ay} width={aW} height={aH}
              fill="rgba(96,165,250,0.25)" stroke={D.GEO_STROKE} strokeWidth="1.5" />
        <circle cx={bcx} cy={bcy} r={br}
                fill="rgba(96,165,250,0.25)" stroke={D.GEO_STROKE} strokeWidth="1.5" />
      </g>

      <text x="140" y="142" fontSize="9" fontFamily="monospace"
            fill="currentColor" opacity="0.4" textAnchor="middle">combines all children into one shape</text>
    </svg>
  );
}
